/* Mission Beard — header nav behaviour (sections/mb-header.liquid)
   - Desktop dropdown: hover-intent + click/keyboard toggle, Esc / outside-click close
   - Mobile drawer: open/close, scroll lock, focus handling, Esc / overlay close
   - Cart: badge count kept in sync with /cart.js; icon opens the Opus Cart drawer when present */
(function () {
  'use strict';
  if (window.__mbHeaderInit) return;
  window.__mbHeaderInit = true;

  var doc = document;
  var root = doc.documentElement;

  function ready(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var header = doc.querySelector('[data-mb-header]');
    if (!header) return;

    /* ── Desktop dropdowns ─────────────────────────────────────── */
    var subs = Array.prototype.slice.call(header.querySelectorAll('[data-mb-sub]'));
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var btn = item.querySelector('[data-mb-sub-toggle]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeAll(except) {
      subs.forEach(function (i) { if (i !== except) setOpen(i, false); });
    }

    subs.forEach(function (item) {
      var btn = item.querySelector('[data-mb-sub-toggle]');
      var timer = null;
      if (!btn) return;

      btn.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        closeAll(item);
        setOpen(item, open);
      });
      item.addEventListener('mouseenter', function () {
        if (!hoverCapable.matches) return;
        clearTimeout(timer);
        closeAll(item);
        setOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        if (!hoverCapable.matches) return;
        timer = setTimeout(function () { setOpen(item, false); }, 120);
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
    });

    doc.addEventListener('click', function (e) {
      if (!subs.length) return;
      var inside = subs.some(function (i) { return i.contains(e.target); });
      if (!inside) closeAll();
    });

    /* ── Mobile drawer ─────────────────────────────────────────── */
    var drawer = doc.querySelector('[data-mb-drawer]');
    var overlay = doc.querySelector('[data-mb-drawer-overlay]');
    // The section wrapper is position:sticky (a stacking context), so move the
    // fixed drawer + overlay to <body> where their z-index is global.
    [overlay, drawer].forEach(function (el) { if (el && el.parentElement !== doc.body) doc.body.appendChild(el); });
    var openBtns = Array.prototype.slice.call(doc.querySelectorAll('[data-mb-drawer-open]'));
    var lastFocus = null;
    var drawerOpen = false;

    function openDrawer() {
      if (!drawer || drawerOpen) return;
      drawerOpen = true;
      lastFocus = doc.activeElement;
      drawer.hidden = false;
      if (overlay) overlay.hidden = false;
      // Next frame so the transition runs from the hidden state.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          if (overlay) overlay.classList.add('is-open');
        });
      });
      root.classList.add('mb-nav-lock');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var close = drawer.querySelector('[data-mb-drawer-close]');
      if (close) setTimeout(function () { close.focus(); }, 60);
    }

    function closeDrawer() {
      if (!drawer || !drawerOpen) return;
      drawerOpen = false;
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      root.classList.remove('mb-nav-lock');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
      }
      drawer.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 350);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    openBtns.forEach(function (b) { b.addEventListener('click', openDrawer); });
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-mb-drawer-close]')) closeDrawer();
      });
      // Basic focus trap.
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusables = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    if (overlay) overlay.addEventListener('click', closeDrawer);

    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawerOpen) closeDrawer();
      else closeAll();
    });

    // Close the drawer if the viewport grows past the mobile breakpoint.
    var mobileMq = window.matchMedia('(max-width: 1099px)');
    var onMq = function (mq) { if (!mq.matches && drawerOpen) closeDrawer(); };
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', onMq);
    else if (mobileMq.addListener) mobileMq.addListener(onMq);

    /* ── Cart icon → Opus Cart drawer ──────────────────────────── */
    Array.prototype.slice.call(doc.querySelectorAll('[data-mb-cart]')).forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (typeof window.opusOpen !== 'function') return; // fall through to /cart
        e.preventDefault();
        try {
          if (typeof window.opusRefreshCart === 'function') window.opusRefreshCart();
          window.opusOpen();
        } catch (err) { window.location.href = el.getAttribute('href') || '/cart'; }
      });
    });

    /* ── Cart badge ────────────────────────────────────────────── */
    var badges = Array.prototype.slice.call(doc.querySelectorAll('[data-mb-cart-count]'));
    function paintCount(n) {
      badges.forEach(function (b) {
        b.textContent = n;
        b.hidden = !(n > 0);
      });
    }
    var refreshTimer = null;
    function refreshCount() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) { if (c && typeof c.item_count === 'number') paintCount(c.item_count); })
          .catch(function () {});
      }, 250);
    }
    window.mbHeaderRefreshCart = refreshCount;

    ['cart:refresh', 'cart:updated', 'cart:add', 'cart:change', 'shopify:cart:add', 'opus:cart:updated']
      .forEach(function (n) {
        doc.addEventListener(n, refreshCount);
        root.addEventListener(n, refreshCount);
      });

    // Any cart mutation through fetch (theme, Opus Cart, apps) refreshes the badge.
    if (window.fetch && !window.fetch.__mbHeaderWrapped) {
      var origFetch = window.fetch;
      var wrapped = function (input, init) {
        var url = '';
        try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
        var p = origFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(url)) {
          p.then(function () { refreshCount(); }, function () {});
        }
        return p;
      };
      wrapped.__mbHeaderWrapped = true;
      window.fetch = wrapped;
    }
    // Legacy XHR adds (jQuery-based theme JS).
    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        try {
          if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
            this.addEventListener('loadend', refreshCount);
          }
        } catch (e) {}
        return origOpen.apply(this, arguments);
      };
    }
  });
})();
